import React, { startTransition, useEffect, useRef, useState } from "react";
import HorecaWidget from "./horecaWidget/HorecaWidget";
import { Outlet, useLocation } from "react-router-dom";
import {
  getWidgetSetUpPosition,
} from "../api/HorecaWidget.service";
import { useDispatch, useSelector } from "react-redux";
import FeedbackComponent from "./feedbackWidget/FeedbackComponent";
import {
  updateButtonPosition,
  updateKey,
  updateResType,
  updateWidgetPosition,
  updateWidgetSetupId,
  updateFloating,
  updateWidgetConfig,
  updateLanguageData,
  updateGuestId,
  updateDeviceId,
} from "../store/slice/widgetSetting.slice";
import TicketingMain from "./ticketingWidget/TicketingMain";
import ActivityWidget from "./ActivitiesWidget/ActivitiesWidget";
import ScanWidget from "./ScanWidget/ScanWidget";
import {
  updateShopType,
  updateWebShopMenuPosition,
} from "../store/slice/Webshop.slice";
import ReservationBooking from "./ReservationBooking/ReservationBooking";
import ReservationOverviewComponent from "./ReservationOverview/ReservationOverviewComponent";
import WebshopMain from './WebshopWidget/WebshopMain'
import KioskMain from "./Kiosk/KioskMain";
import TVWidgetDineIn from "./TV/TVWidgetDineIn";
import TVWidgetPickup from "./TV/TVWidgetPickup";
import HotelWidgetMain from "./HotelWidget/HotelWidgetMain";
import SalonWidget from "./salonWidget/SalonWidget";
import OpeningHours from "./openingHours/openingHoursSalon";
import CancelReservation from "./horecaWidget/CancelReservation";
import Kitchen from "./kitchen/Kitchen";


const WidgetDynamicLoading = () => {

  const dispatch = useDispatch();
  const location = useLocation();
  const {
    widgetSetupId,
    key,
    buttonPosition,
    resType,
    widgetPosition,
    floating,
  } = useSelector((store) => store?.widgetSettings);
 
  const queryParams = new URLSearchParams(location.search);
  let secretKey=queryParams.get('secretkey')
 const [demoPos,setDemoPos]=useState('')
  const setupIdRef = useRef(widgetSetupId);
  const[widgetPositionLoading,setWidgetPositionLoading]=useState(false)

  const fetchWidgetSetupPosition = async (widgetSetupId) => {
   
    if (widgetSetupId == setupIdRef.current) return;
    setupIdRef.current = widgetSetupId;
    setWidgetPositionLoading(true)
    try {
      const response = await getWidgetSetUpPosition(widgetSetupId);
      if (response?.status == 200) {
        startTransition(() => {
          dispatch(updateWidgetPosition(response?.data?.positionButton));
        });
      }
      setWidgetPositionLoading(false)
    } catch (error) {
      console.error("Error fetching widget settings:", error?.message);
      setWidgetPositionLoading(false)
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    localStorage.removeItem('deviceId')
    const setupId = queryParams.get("widgetsetupid");
    const keyParam = queryParams.get("key");
    const langParam = queryParams.get("lang");
    const buttonPositionParam = queryParams.get("buttonposition");
    const resTypeParam = queryParams.get("resType");
    const floatingParam = queryParams.get("floating");
    const position = queryParams.get("position");
    const shopType = queryParams.get("shoptype");
    const guestId=queryParams?.get('guestId')
    const deviceId=queryParams?.get('deviceId')
    const widgetPositionURL=queryParams?.get('widgetPosition')
    if(setupId){
      fetchWidgetSetupPosition(setupId);
    }
    localStorage.setItem(
      "widget",
      JSON.stringify({
        id: setupId,
        key: keyParam,
        lang: langParam,
        resType:resTypeParam,

        
      })
    );

    if(deviceId && deviceId != 'null'){
    localStorage.setItem(
      "deviceId",
      JSON.stringify(
     deviceId
      )
    );
      }
      setDemoPos(widgetPositionURL)
    dispatch(updateWidgetSetupId(setupId));
    dispatch(updateKey(keyParam));
    dispatch(updateButtonPosition(buttonPositionParam));
    dispatch(updateResType(resTypeParam));
    dispatch(updateFloating(floatingParam));
    dispatch(updateWebShopMenuPosition(position));
    dispatch(updateShopType(shopType));
    dispatch(updateGuestId(guestId))
    if( deviceId && deviceId != 'null'){
      dispatch(updateDeviceId(deviceId))
    }
    
  }, [location]);
// Run this when iframe loads
useEffect(() => {
  let parentUrl = document.referrer;

  // If referrer is empty, fallback to same-origin
  if (!parentUrl) {
    const { origin, pathname, search, hash } = window.location;
    // Fallback: use iframe's current full URL
    parentUrl = `${origin}${pathname}${search}${hash}`;
    console.warn("⚠️ Referrer was empty — using iframe's full URL as fallback:", parentUrl);
  }

  localStorage.setItem('parentUrl', parentUrl);
}, []);
  if (key && resType?.toLowerCase() === "horeca") {
    return (
      <div>
        <HorecaWidget
          widgetSetupId={widgetSetupId}
          buttonPosition={buttonPosition}
          resType={resType}
          widgetPosition={widgetPosition}
          floating={floating}
          widgetpos={demoPos}
        />
      </div>
    );
  } 
  else if (secretKey && resType?.toLowerCase() === "feedback") {

    return (
      <div>
        <FeedbackComponent
          buttonPosition={buttonPosition || "Bottom-Right"}
          resType={resType}
          widgetPosition={widgetPosition}
        />
      </div>
    );
  } else if (key && resType?.toLowerCase() === "ticketing") {
    return (
      <div>
        <TicketingMain
          widgetSetupId={widgetSetupId}
          buttonPosition={buttonPosition || "Bottom-Right"}
          resType={resType}
          widgetPosition={widgetPosition}
          floating={floating}
          widgetpos={widgetPosition}
        />
      </div>
    );
  
  } else if (key && resType?.toLowerCase() === "activity") {
    return (
      <div>
        <ActivityWidget
          widgetSetupId={widgetSetupId}
          buttonPosition={buttonPosition || "Bottom-Right"}
          resType={resType}
          widgetPosition={widgetPosition}
          floating={floating}
          widgetpos={demoPos}
        />
      </div>
    );
  } else if (key && resType?.toLowerCase() === "scan") {
    return (
      <div>
        <ScanWidget />
      </div>
    );
  } 
  else if (key && resType?.toLowerCase() === "reservation") {
    return (
      <div>
        <ReservationBooking floating={floating} />
      </div>
    );
    
  }
  else if (key && resType?.toLowerCase() === "reservationoverview") {
    return (
      <div>
        {/* <ReservationOverview /> */}
        <ReservationOverviewComponent />
      </div>
    );
    
  }
  else if (key && resType?.toLowerCase() === "webshop") {
    return (
      <div>
        <WebshopMain
          widgetSetupId={widgetSetupId}
          buttonPosition={buttonPosition}
          resType={resType}
          widgetPosition={widgetPosition}
          floating={floating}
        />
      </div>
    );
  
  }
  

  else if (key && resType?.toLowerCase() === "hotel") {
    return (
      <div>
        <HotelWidgetMain
          widgetSetupId={widgetSetupId}
          buttonPosition={buttonPosition}
          resType={resType}
          widgetPosition={widgetPosition}
          floating={floating}
        />
      </div>
    );}
  else if (key && resType?.toLowerCase() === "salon") {
      return (
        <div>
        <SalonWidget
          widgetSetupId={widgetSetupId}
          buttonPosition={buttonPosition || "Bottom-Right"}
          resType={resType}
          widgetPosition={widgetPosition}
          floating={floating}
        />
      </div>
   
      );
    } 
  else if(resType?.toLowerCase() === "kitchen"){
    return <Kitchen />
  }
 
    else if (key && (resType?.toLowerCase() === 'horecaopeninghours' ||
     resType?.toLowerCase() === 'activityopeninghours' ||
     resType?.toLowerCase() === 'ticketingopeninghours'  ||
     resType?.toLowerCase() === "salonopeninghours" ||
     resType?.toLowerCase() === 'webshopopeninghours'   )) {
      return (
        <div>
        <OpeningHours
          widgetSetupId={widgetSetupId}
          buttonPosition={buttonPosition || "Bottom-Right"}
          resType={resType}
          widgetPosition={widgetPosition}
          floating={floating}
        />
      </div>
   
      );
    } 
   else if (key && resType?.toLowerCase() === "kiosk") {
    return (
      <div>
        <KioskMain
          widgetSetupId={widgetSetupId}
          buttonPosition={buttonPosition}
          resType={resType}
          widgetPosition={widgetPosition}
          floating={floating}
        />
      </div>
    );
  } 

  else if (key && resType?.toLowerCase() === "dinein") {
    return (
      <div>
        <TVWidgetDineIn />
      </div>
    );
    
  }
  else if (key && secretKey && resType== 'cancel'){
    return(
      <div>
        <CancelReservation 
        key={key}
        secretKey={secretKey}
        />
      </div>
    )
  }
  else if (key && resType?.toLowerCase() === "pickup") {
    return (
      <div>
        <TVWidgetPickup />
      </div>
    );
    
  }
   else {
    return (
      <div>
        {/* Outlet for nested routes */}
        <Outlet />
      </div>
    );
  }
};

export default WidgetDynamicLoading;
